import { PersistPartial } from 'redux-persist/es/persistReducer';
import { RootState } from 'store/reducers/types';
import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer, Persistor, PersistConfig } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "store/reducers";

const persistConfig: PersistConfig<RootState> = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer<RootState>(persistConfig, rootReducer);
const configureStore = (initialState?: RootState & PersistPartial) => {
  const composeEnhancers = composeWithDevTools({});

  return createStore(
    persistedReducer,
    initialState,
    composeEnhancers(applyMiddleware(thunk))
  );
};

const store = configureStore();

export default store;
export type AppDispatch = typeof store.dispatch;
export const persistor: Persistor = persistStore(store);
